import { useState } from 'react';
import './App.css';
import './vivo-home.css';
import 'bulma';
import HomePage from './HomePage';
import Footer from './Footer';
import PrivacyPage from './PrivacyPage';
import TermsAndConditions from './TermsAndConditions';
import ContactModal from './Modal';

function AppContent({ onOpenContact }) {
  const path = window.location.pathname;

  if (path === '/privacy') return <PrivacyPage />;
  if (path === '/terms') return <TermsAndConditions />;
  return <HomePage onOpenContact={onOpenContact} />;
}

function App() {
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <div className="App">
      <div className="app-router">
        {contactOpen && (
          <ContactModal setToggleModal={() => setContactOpen(false)} />
        )}
        <div className="app-router-main">
          <AppContent onOpenContact={() => setContactOpen(true)} />
        </div>
        <Footer onOpenContact={() => setContactOpen(true)} />
      </div>
    </div>
  );
}

export default App;
